import "./ErrorBox.css";

export default function Error({ mes }) {
  return (
    <label className="ErrorMessage">
      <i>{mes}</i>
    </label>
  );
}
